import styled from 'styled-components'
import Button from '../../../components/Button'
import InputGroup from 'react-bootstrap/InputGroup'

export const ShowAllFilter = styled(Button)`
  height: 40px;
  margin: 0 12px 0;

  @media (max-width: 415px) {
    margin: 24px auto;
  }
`

export const SelectCheckBox = styled(InputGroup.Checkbox)``

export const SelectAllWrapper = styled.div`
  width: 120px;
  height: 40px;
  display: flex;
  margin: 0;
`
